/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component, useState } from "react";
import { useHistory } from "react-router";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import PAGE from "../../utils/Destination";
import { useDispatch, useSelector } from "react-redux";
import * as userSelectors from "../../selectors/user";
import _ from "lodash";
import clsx from "clsx";
import * as axiosInstance from "../../services/axiosInstance";
import * as authSelectors from "../../selectors/auth";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import * as userActions from "../../action/user";
import Helper from "../../utils/Helper";
import CustomConfirmationModal from "../CustomConfirmationModal";
import routes from "../../routes";
import NotificationMessage from "../../utils/NotificationMessage";
import {getUserAccountKey} from "../../selectors/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons";
import { setIpoConfig } from "../../action/ipo";
import * as ipoActions from "../../action/ipo";
import LoadingOverlay from "../LoadingOverlay";

function HeaderNav() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const [show, setShow] = useState(false);
  const accountSelections = userSelectors.getUserAccountSelections(userState);
  const selectedAccount = _.find(accountSelections, "is_selected");
  const currenciesSelections = userSelectors.getUserAccountSelectionsCurrencies(selectedAccount);
  const selectedCurrency = _.find(currenciesSelections, "is_selected");

  const onClickSwitchCode = (e, clientCode, currencyCode) => {
    e.preventDefault();

    const locationPath = _.get(history,['location','pathname'],'')
    const targetRoutes=_.find(routes,_.matchesProperty('path',locationPath))
    if(!_.isEmpty(targetRoutes)){
      if(_.get(targetRoutes,['isNotSwitchable'],false)){
        NotificationMessage.error("You are not perform this action while doing any settlement")
        return
      }
    }
    if (_.isEqual(clientCode, userSelectors.getUserAccountText(selectedAccount))) {
      return;
    }
    if (_.isEqual(currencyCode, userSelectors.getUserAccountText(selectedCurrency))) {
      return;
    }
    submitSwitchCodeRequest({
      client_code: !_.isEmpty(clientCode) ? clientCode : userSelectors.getUserAccountKey(selectedAccount),
      currency_code: !_.isEmpty(currencyCode)
        ? currencyCode
        : userSelectors.getUserAccountKey(selectedCurrency),
    });
  };

  const submitSwitchCodeRequest = async (postData) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("clientarea/profile/switch-client", postData);
      dispatch(userActions.updateUserDetail(response.data));
      dispatch(ipoActions.setIpoConfig(null));
      dispatch(ipoActions.removeIPODetail(null));
      setTimeout(()=>{
        window.location.reload();
      },1500)
    } catch (e) {
      Helper.handleHttpError(e, dispatch);
    } finally {
      setLoading(false);
    }
  };

  const onClickNavigate = (e, page) => {
    e.preventDefault();
    history.push(page);
  };
  const onClickLogout = () => {
    // setShow(true);
    startLogout()
  };
  const startLogout = async() => {

    setLoading(true)
    try {
      const response = await axiosInstance.post(
        "clientarea/profile/logout",
        null,
        false,
        false,
        "",
      );
      if (response && response.status) {
        localStorage.removeItem("ta-token");
        dispatch(ipoActions.setIpoConfig(null));
        dispatch(ipoActions.removeIPODetail(null));
        history.push(`/`);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  };

  return (
    <Navbar className="d-none d-lg-block d-md-none default-bg" expand="lg">
      <Container
        fluid
        className="d-flex flex-row justify-content-between align-items-center"
      >
        <div className="d-flex align-items-center ml-2 ml-lg-0 main-logo">
          <a
            href={PAGE.DASHBOARD}
            onClick={(e) => onClickNavigate(e, PAGE.DASHBOARD)}
          >
            <Image src="/img/ta-securities-logo.png" className="brandLogo" alt="logo" />
          </a>
        </div>
        <div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="nav mr-auto" navbar>
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  className="nav-toggle-outter m-0 asButton me-2"
                >
                  <span className="d-lg-block">
                    {userSelectors.getUserAccountText(selectedAccount)}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {!_.isEmpty(accountSelections)
                    ? _.map(accountSelections, (account, index) => {
                        const name = userSelectors.getUserAccountText(account);
                        const isSelected =
                          userSelectors.getUserAccountSelectionsCurrenciesIsSelected(
                            account,
                          );
                        return (
                          <Dropdown.Item
                            key={index}
                            href="#"
                            className={clsx("", {
                              ["text-primary"]: isSelected,
                            })}
                            onClick={(e) => onClickSwitchCode(e, name, "")}
                          >
                            {name}
                          </Dropdown.Item>
                        );
                      })
                    : false}
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  className="nav-toggle-outter m-0 asButton"
                >
                  <span className="d-lg-block">
                    {userSelectors.getUserAccountText(selectedCurrency)}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="noMinWidth">
                  {!_.isEmpty(currenciesSelections)
                    ? _.map(currenciesSelections, (currency, index) => {
                        const name = userSelectors.getUserAccountText(currency);
                        const key = userSelectors.getUserAccountKey(currency);
                        const isSelected =
                          userSelectors.getUserAccountSelectionsCurrenciesIsSelected(
                            currency,
                          );
                        return (
                          <Dropdown.Item
                            href="#"
                            key={index}
                            className={clsx("", {
                              ["text-primary"]: isSelected,
                            })}
                            onClick={(e) => onClickSwitchCode(e, "", key)}
                          >
                            {name}
                          </Dropdown.Item>
                        );
                      })
                    : false}
                </Dropdown.Menu>
              </Dropdown>
              <button
                className={clsx("btn btn-logout m-0 ms-2")}
                onClick={(e) => onClickNavigate(e,PAGE.PROFILE)}
              >
                <FontAwesomeIcon icon={faUserCircle} size='xl' />
              </button>
              <button
                className={clsx("btn btn-logout m-0 ms-2")}
                onClick={() => onClickLogout()}
              >
                Logout
                <LoadingOverlay isSemiLoading={true} loading={loading}></LoadingOverlay>
              </button>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Container>
      <CustomConfirmationModal
        title="Confirm Logout"
        desc="Are you confirm to logout?"
        handleClose={() => setShow(false)}
        confirm={startLogout}
        show={show}
      ></CustomConfirmationModal>
    </Navbar>
  );
}

export default HeaderNav;
